<template>
  <div class="about-container">
    <div class="banner">
      <div class="banner-div w">
        <div class="banner-title">广州言成科技有限公司</div>
        <div class="banner-content">
          打造本地生活权益矩阵，高效推动平台数字化营销
        </div>
      </div>
    </div>

    <div class="nav w">
      <ul class="nav-ul success-list">
        <li class="nav-li">
          <p class="nav-p1">
            <span class="scroll-num num0">200</span><span>+</span>
          </p>
          <p class="nav-p2">品牌运营</p>
          <span class="nav-strip"></span>
        </li>
        <li class="nav-li">
          <p class="nav-p1">
            <span class="scroll-num num1">8</span><span>年</span>
          </p>
          <p class="nav-p2">专注互联网行业</p>
          <span class="nav-strip"></span>
        </li>
        <li class="nav-li">
          <p class="nav-p1">
            <span class="scroll-num num2">3000</span><span>万+</span>
          </p>
          <p class="nav-p2">私域用户</p>
          <span class="nav-strip"></span>
        </li>
        <li class="nav-li">
          <p class="nav-p1">
            <span class="scroll-num num3">10000</span><span>+</span>
          </p>
          <p class="nav-p2">私域社群</p>
        </li>
      </ul>
    </div>

    <div class="group about-us">
      <div class="w">
        <div v-inview="'animate__lightSpeedInLeft'" class="group-title">
          关于我们
        </div>
        <div class="about-us-con">
          <div class="img">
            <img src="../assets/aboutUs-building.png" alt="" />
          </div>
          <div class="con">
            <div class="tit">广州言成科技有限公司</div>
            <div class="blue"></div>
            <div class="txt">
              <div>
                <span style="color: #4080ff">广州言成科技有限公司</span>
                成立于2019年01月24日，是一家专注于私域运营的互联网电商企业。
              </div>
              <div>
                其创始人
                <span style="color: #4080ff">臧诚</span>
                深耕用户增长、微信生态领域8年，通过“技术-产品-运营-增长“的四维驱动模型，打造出以技术驱动产品、以产品驱动运营、以运营驱动增长的商业闭环。
              </div>
              <div>
                公司专注私域电商与会员权益，拥有超过一万个电商私域社群，并与饿了么，美团、滴滴等多家互联网巨头建立了合作。除提供电商产品外，还为用户带来外卖、打车、电影等多种优惠券权益。
              </div>
              <div>
                公司旗下现有超30名员工，涵盖了研发团队、运营团队、CPS团队等多个关键部门。因其丰富的行业背景及强大的团队，公司正处于飞速发展阶段。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="group contact-us">
      <div class="w">
        <div v-inview="'animate__lightSpeedInRight'" class="group-title">
          联系我们
        </div>
        <div class="contact-us-con">
          <div class="contact-list">
            <div
              class="contact-item"
              v-for="(item, index) in contactList"
              :key="index"
            >
              <div class="icon">
                <img :src="item.icon" alt="" />
              </div>
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </div>
          <div class="map">
            <div
              style="width: 100%; height: 100%"
              id="allmap"
              ref="allmap"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      nowPath: "",
      contactList: [
        {
          icon: require("../assets/dizhi.png"),
          title: "地址",
          content: "广州市海珠区新港东路70号之十二自编203室",
        },
        {
          icon: require("../assets/email.png"),
          title: "商务合作",
          content: "19066503932@163.com",
        },
        {
          icon: require("../assets/kf.png"),
          title: "技术支持",
          content: "13802324908",
        },
      ],
    };
  },
  created() {},
  watch: {
    $route: {
      handler: function (val) {
        var that = this;
        that.nowPath = val.fullPath;
        window.scrollTo(0, 0);
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    var map = new BMapGL.Map(this.$refs.allmap); // 创建地图实例
    var point = new BMapGL.Point(113.390409, 23.101047); // 创建点坐标
    map.centerAndZoom(point, 19); // 初始化地图，设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    map.setHeading(64.5); //设置地图旋转角度
    map.setTilt(73); //设置地图的倾斜角度
    var scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
    map.addControl(scaleCtrl);
    //创建地址解析器实例
    var myGeo = new BMapGL.Geocoder();
    // 将地址解析结果显示在地图上，并调整地图视野
    myGeo.getPoint(
      "广东省广州市海珠区万胜汇·创客PARK10栋203",
      function (point) {
        if (point) {
          map.centerAndZoom(point, 16);
          map.addOverlay(
            new BMapGL.Marker(point, {
              title: "广东省广州市海珠区万胜汇·创客PARK10栋203",
            })
          );
        } else {
          alert("您选择的地址没有解析到结果！");
        }
      },
      "北京市"
    );
  },
};
</script>

<style lang="less" scoped>
.about-container {
  min-height: calc(100vh - 60px - 360px);
  // background-color: #f5f5f5;

  .group {
    padding: 60px 0;

    .group-title {
      margin-bottom: 30px;
      font-weight: 600;
      font-size: 36px;
      text-align: center;
      color: #1d2129;
    }
  }

  .about-us {
    .about-us-con {
      display: flex;
      justify-content: space-between;

      .img {
        width: 460px;
        height: 340px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .con {
        flex: 1;
        padding: 20px;

        .tit {
          font-size: 30px;
          line-height: 22px;
          color: #333333;
        }

        .blue {
          width: 69px;
          height: 3px;
          background-color: #4080ff;
          margin: 19px 0 27px 0;
        }

        .txt {
          font-size: 17px;
          line-height: 30px;
          color: #666666;
        }
      }
    }
  }

  .contact-us {
    background-color: #f5f6f7;
    .contact-us-con {
      padding: 0 16px;

      .contact-list {
        display: flex;
        align-items: center;
        gap: 16px;

        .contact-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100px;
          background-color: #fff;

          .icon {
            width: 60px;
            height: 60px;
          }

          .info {
            margin-left: 10px;
            .title {
              font-weight: 500;
              font-size: 20px;
            }
            .content {
              font-size: 14px;
              color: #4e5969;
            }
          }
        }
      }

      .map {
        margin-top: 20px;
        width: 100%;
        height: 450px;
      }
    }
  }

  .banner {
    height: 250px;
    background: url(../assets/aboutUs-banner.png) no-repeat center;
    background-color: #fff;

    .banner-div {
      padding: 62px 16px 0;
      .banner-title {
        font-size: 40px;
        line-height: 22px;
        color: #333333;
      }

      .banner-content {
        font-size: 17px;
        line-height: 22px;
        color: #555555;
        margin-top: 19px;
      }
    }
  }

  .nav {
    margin: -62px auto 0;
    box-shadow: 0 2px 10px 0 rgba(51, 51, 51, 0.1);
    border-radius: 10px;
    background-color: #fff;

    .nav-ul {
      margin: 0 auto;
      display: flex;

      .nav-li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 150px;

        .nav-p1 {
          span {
            font-size: 34px;
            color: #275aff;
          }
        }
        .nav-p2 {
          font-size: 18px;
          color: #333;
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 768px) and (max-width: 991px) {
  .about-container {
    .about-us {
      .about-us-con {
        flex-direction: column;
        align-items: center;

        .con {
          margin-top: 20px;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .about-container {
    .nav {
      .nav-ul {
        flex-direction: column;

        .nav-li {
          padding: 30px 0;
        }
      }
    }
    .about-us {
      .about-us-con {
        flex-direction: column;
        align-items: center;

        .img {
          width: 100%;
        }

        .con {
          margin-top: 20px;
        }
      }
    }

    .contact-us {
      .contact-us-con {
        .contact-list {
          flex-direction: column;

          .contact-item {
            padding: 16px;
            width: 100%;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}
</style>
